<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.6)"
  size="medium"
  color="#fff"
  type="test">
  <div style="color: white; text-align: center;">
    <ul style="list-style: none;">
      <li><h1 class="titulo">certicámara.</h1></li>
      <li>
        <div class="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </li>
    </ul>
  </div>
</ngx-spinner>
<router-outlet></router-outlet>